import copy from 'copy-html-to-clipboard';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';

export const copySearchResultRowsToClipboard = (
  rows: { [key: string]: any }[],
  columnHeaders: string[],
): boolean => {
  if (!rows?.length || !columnHeaders?.length) {
    return false;
  }

  try {
    const tab = '</td><td>';
    let tableRows = `<tr><th>${columnHeaders.join('</th><th>')}</th></tr>`;
    rows.forEach((row) => {
      tableRows += `<tr><td>${columnHeaders
        .map((header) => row?.[header] ?? '')
        .join(tab)}</td></tr>\n`;
    });

    copy(
      `<!Doctype html><html><head><title></title></head><body style="font-family:'Times New Roman'"><table border="1">${tableRows}</table></body></html>`,
      { asHtml: true },
    );

    showAlertSnackBar(EAlertType.SUCCESS, ESnackBarPosition.TOP, 'Copied to clipboard');
    return true;
  } catch (err) {
    console.error(err);
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      'Could not copy to clipboard',
    );
    return false;
  }
};
